module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-whyus-photo-02.jpg?h=e9372f753822c27f347c7a0d8d0ed6d1";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-whyus-photo-02.jpg
// module id = 2121
// module chunks = 12 15